import { actions } from 'Data/ReduxViewModels/Authentication';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from '../../Core';
import Login from './Login';

const AuthPage = () => {
  const isRetrievingSettings = useSelector((state) => state.authentication.isRetrievingSettings);
  const isRetrievingUser = useSelector((state) => state.user.isRetrievingUser);
  const isSubmittingForcedChangeCredentials = useSelector(
    (state) => state.authentication.isAuthenticating && !!state.authentication.mustChangeMessage
  );
  const isLoggedIn = useSelector((state) => state.authentication.isAuthenticated);
  const isEntraInitialising = useSelector((state) => state.authentication.entra.isInitialising);
  const isEntraInitialised = useSelector((state) => state.authentication.entra.isInitialised);
  const isAuthenticating = useSelector((state) => state.authentication.isAuthenticating);
  const isEntraAuthenticating = useSelector((state) => state.authentication.entra.isAuthenticating);
  const authChecked = useSelector(pipe((state) => state.authentication.authChecked));
  const isEntraEnabled = useSelector(
    pipe((state) => state.authentication.authSettings?.isEntraEnabled, valueOrDefault(false))
  );
  const autoLogin = useSelector((state) => state.authentication.entra.autoLogin);
  const showSpinner =
    isRetrievingSettings ||
    isRetrievingUser ||
    isSubmittingForcedChangeCredentials ||
    isEntraAuthenticating ||
    (isEntraEnabled && (isEntraInitialising || isAuthenticating));
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getPlatformVersion());
    dispatch(actions.checkLogin());
  }, [dispatch]);

  useEffect(() => {
    if (!authChecked || !isEntraInitialised || isLoggedIn || !autoLogin || isAuthenticating) return;
    dispatch(actions.postEntraLogin());
  }, [dispatch, isLoggedIn, isEntraInitialised, autoLogin]);

  return <main>{showSpinner || isLoggedIn ? <Spinner large /> : <Login />}</main>;
};

export default AuthPage;
